import { useState } from 'react';
import AccountDetails from './accountDetails';
import AlertPreference from './alertPreference';
import Newsletter from './newsletter';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tab, Tabs, Typography, Box, useTheme } from '@mui/material';

const tabMap = {
    "/settings": 0,
    "/settings/newsletters": 1,
};

const reverseTabMap = ["account", "newsletters"];

export default function Settings() {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const activeTab = tabMap[location.pathname] ?? 0;

    const handleChange = (_, newValue) => {
        if (newValue === 0) navigate("/settings");
        if (newValue === 1) navigate("/settings/newsletters");
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: theme.palette.background.default,
                px: { xs: 2, md: 4 },
                py: 3.5,
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                }}
            >
                <Box>
                    <Typography
                        variant="title"
                        fontWeight="var(--font-weight-bold)"
                        sx={{ color: 'var(--color-text-primary)', display: 'block' }}
                        letterSpacing="-0.02em"
                        mb={0.5}
                    >
                        Settings
                    </Typography>
                    <Typography variant="subtitle" fontWeight="var(--font-weight-normal)" sx={{ color: 'var(--color-text-muted)' }}>
                        Manage your account preferences and notification settings
                    </Typography>
                </Box>
            </Box>

            {/* Tabs */}
            <Box sx={{ borderBottom: `1px solid ${theme.palette.border.secondary}`, mb: 2 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    sx={{
                        "& .MuiTabs-indicator": {
                            backgroundColor: theme.palette.text.primary,
                            height: "2px",
                        },
                    }}
                >
                    <Tab
                        label="Account"
                        sx={{
                            textTransform: "none",
                            fontSize: "var(--font-size-base)",
                            fontWeight: 500,
                            color: theme.palette.text.muted,
                            "&.Mui-selected": {
                                color: theme.palette.text.primary,
                            },
                        }}
                    />
                    <Tab
                        label="Newsletters"
                        sx={{
                            textTransform: "none",
                            fontSize: "var(--font-size-base)",
                            fontWeight: 500,
                            color: theme.palette.text.muted,
                            "&.Mui-selected": {
                                color: theme.palette.text.primary,
                            },
                        }}
                    />
                </Tabs>
            </Box>

            {/* Tab Content */}
            <Box>
                {activeTab === 0 && <AccountDetails />}
                {activeTab === 1 && <Newsletter />}
            </Box>
        </Box>
    );
}